import { render, staticRenderFns } from "./view-PendingReview.vue?vue&type=template&id=5ef98524&scoped=true&"
import script from "./view-PendingReview.vue?vue&type=script&lang=js&"
export * from "./view-PendingReview.vue?vue&type=script&lang=js&"
import style0 from "./view-PendingReview.vue?vue&type=style&index=0&id=5ef98524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef98524",
  null
  
)

export default component.exports